import React, { useState, useEffect } from 'react';
import './AuditResults.css';
import { AiOutlineCheck, AiOutlineClose  } from "react-icons/ai";
import { AiFillLock } from "react-icons/ai";
import { LiaExternalLinkAltSolid } from "react-icons/lia";
import AddressDisplay from '../addressdisplay/AddressDisplay';
import { FaSquareFull } from "react-icons/fa";
import { MdOutlineInfo } from "react-icons/md";
import { TokenItem } from '../../utils/types';

const CheckIcon = AiFillLock as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const TimesIcon = AiOutlineClose as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const External = LiaExternalLinkAltSolid as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Square = FaSquareFull as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Info = MdOutlineInfo as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

interface AuditResultsProps {
  tokens: TokenItem[];
  ca: string;
}

const AuditResults: React.FC<AuditResultsProps> = ({ tokens, ca }) => {
  if (tokens.length === 0 || tokens[0].meta.badges.Audited === "false") {
    return <div className='not-found'>
        <div>Do you want to get audited by Coinsult?</div>
        <a className='full-button' target='_blank' href='https://t.me/coinsult_tg'>Request Audit</a>
      </div>;
  }
  

  return (
    <div className='audit-wrapper'>
        <div key={tokens[0].id} className='token-audit-result'>
          <div className="token-result">
            <div className="audit-items">
            <div className="audit-item">
                <div
                  className="dex-title"
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content="Indicating if the owner needs to enable trading before you can buy or sell"
                >
                  <Info /> Enable trading
                </div>
                <div className="action">
                  {tokens[0].meta.centralization["Enable trading"] === "false" ? (
                    <>
                      <CheckIcon style={{ color: 'rgb(14, 203, 129)' }} />
                      <>Trading Enabled</>
                    </>
                  ) : (
                    <>
                      <TimesIcon style={{ color: 'rgb(246, 70, 93)' }} />
                      <>Manual listing</>
                    </>
                  )}
                </div>
              </div>
              <div className="audit-item">
                <div 
                  className="dex-title" 
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content="If true, the owner can mint new tokens."
                >
                  <Info /> Mint
                </div>
                <div className='action'>
                  {tokens[0].meta.centralization["Mint"] === "false" ? (
                    <>
                      <CheckIcon style={{ color: 'rgb(14, 203, 129)' }} />
                      <>Cannot mint</>
                    </>
                  ) : (
                    <>
                      <TimesIcon style={{ color: 'rgb(246, 70, 93)' }} />
                      <>Can mint</>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="audit-items">
              <div className="audit-item">
                <div
                  className="dex-title"
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content="If true, the contract can blacklist certain addresses."
                >
                  <Info /> Blacklist
                </div>
                <div className="action">
                  {tokens[0].meta.centralization["Blacklist"] === "false" ? (
                    <>
                      <CheckIcon style={{ color: 'rgb(14, 203, 129)' }} />
                      <>No blacklist</>
                    </>
                  ) : (
                    <>
                      <TimesIcon style={{ color: 'rgb(246, 70, 93)' }} />
                      <>Blacklist</>
                    </>
                  )}
                </div>
              </div>

              <div className="audit-item">
                <div
                  className="dex-title"
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content="If true, transaction fees exceed 25%."
                >
                  <Info /> High fees
                </div>
                <div className="action">
                  {tokens[0].meta.centralization["High fees (\u003E25%)"] === "false" ? (
                    <>
                      <CheckIcon style={{ color: 'rgb(14, 203, 129)' }} />
                      <>No high fees</>
                    </>
                  ) : (
                    <>
                      <TimesIcon style={{ color: 'rgb(246, 70, 93)' }} />
                      <>High fees</>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="audit-items">
              <div className="audit-item">
                <div
                  className="dex-title"
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content="If true, there's a maximum limit on each transaction."
                >
                  <Info /> Max tx
                </div>
                <div className="action">
                  {tokens[0].meta.centralization["Max tx"] === "false" ? (
                    <>
                      <CheckIcon style={{ color: 'rgb(14, 203, 129)' }} />
                      <>No max tx</>
                    </>
                  ) : (
                    <>
                      <TimesIcon style={{ color: 'rgb(246, 70, 93)' }} />
                      <>Max Tx</>
                    </>
                  )}
                </div>
              </div>
              <div className="audit-item">
                <div 
                  className="dex-title" 
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content="If true, the token might block sells (become a honeypot)."
                >
                  <Info /> Honeypot
                </div>
                <div className='action'>
                  {tokens[0].meta.centralization["Honeypot"] === "false" ? (
                    <>
                      <CheckIcon style={{ color: 'rgb(14, 203, 129)' }} />
                      <>No honeypot</>
                    </>
                  ) : (
                    <>
                      <TimesIcon style={{ color: 'rgb(246, 70, 93)'}} />
                      <>Honeypot</>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

        <div className='audit-right'>
          <div className="audit-items">
            <div className="audit-item result">
              <div className="result-header">
                <div className='audit-title-button'>
                  Code Audit
                  {tokens[0].meta.report_url && (
                    <div className='noted-pending'>
                      <a className='audit-button' href={tokens[0].meta.report_url} target="_blank" rel="noopener noreferrer">
                        <External />Full Report
                      </a>
                    </div>
                  )}
                </div>
                <div>
                <a className='risk-link' href={tokens[0].meta.report_url} target="_blank" rel="noopener noreferrer">
                  <div
                    className={`risk-amount ${tokens[0].meta.pending != "0" ? 'medium' : 'low'}`}
                  >
                      {tokens[0].meta.pending} pending
                  </div>
                  </a>
                </div>
              </div>

              <div className="bottom-result">
                <div>Audited Contract</div>
                <div><AddressDisplay address={ca} /></div>
              </div>
            </div>
          </div>
          <div className="audit-items">
            <div className="audit-item risks-square">
              <div className='audit-issue-square'>
                <div className='square-cat'><Square style={{ color: 'rgb(14, 203, 129)' }}  /><div className='info-div'><Info data-tooltip-id="global-tooltip" data-tooltip-content="Will not bring problems"/>  Low Risk</div></div>
                <a style={{textDecoration: "none"}} href={tokens[0].meta.report_url} target="_blank" rel="noopener noreferrer"><div className="risk-amount grey">{tokens[0].meta.low} issues</div></a>
              </div>
              <div className='audit-issue-square'>
              <div className='square-cat'><Square style={{ color: 'rgb(203, 197, 14)' }}  /><div className='info-div'><Info data-tooltip-id="global-tooltip" data-tooltip-content="Can bring problems"/>  Medium Risk</div></div>
              <a style={{textDecoration: "none"}} href={tokens[0].meta.report_url} target="_blank" rel="noopener noreferrer"><div className="risk-amount grey">{tokens[0].meta.medium} issues</div></a>
              </div>
              <div className='audit-issue-square'>
                <div className='square-cat'><Square style={{ color: 'rgb(246, 70, 93)' }}  /><div className='info-div'><Info data-tooltip-id="global-tooltip" data-tooltip-content="Will bring problems" /> High Risk</div></div>
                <a style={{textDecoration: "none"}} href={tokens[0].meta.report_url} target="_blank" rel="noopener noreferrer"><div className="risk-amount grey">{tokens[0].meta.high} issues</div></a>
              </div>
            </div>
            {/* <div className="audit-item">
              Codebase
              <a className='audit-button' href={token.meta.report_url} target="_blank" rel="noopener noreferrer">
                <External />Full Report
              </a>
            </div> */}
          </div>
        </div>
        </div>
    </div>
  );
};

export default AuditResults;
